import { Component, OnInit } from "@angular/core";
import { APGTestingService } from "../agptesting-newview/apgtesting.service";
import {  ResP } from "../agptesting-newview/model/result";
import { SelectableLab } from "../carrier/selectable-lab";
import { MasterDataService } from "../masterdata/masterdata.service";
import { MessagesService } from "../messages/messages.service";

@Component({
  selector: "app-apg-parentage",
  templateUrl: "./apg-parentage.component.html",
  styleUrls: ["./apg-parentage.component.css"],
})
export class ApgParentageComponent implements OnInit {

  puid: string;
  sampleToSearch: string;
  selectedLabId: string;
  sampleSearchDisabled = true;
  dirty: any;
  confirmationService: any;
  scanDialogMessage: any;
  blocked: boolean;

  samples: any = [];
  finalData: any = [];
  selectedSample: any;
  selectableLab: SelectableLab;
  markerNames: string[];
  samplesData: any = [];
  subTypeList = [];
  resP: ResP;
  searchSample: string;
  fatherArray=[];
  motherArray=[];
  childArray=[];
  selectedRow = [];
  constructor(private apgTestingService: APGTestingService, private _masterDataService: MasterDataService, private _messagesService: MessagesService,) { }
  ngOnInit(): void {
    this.puid = localStorage.getItem('PUID');
    this.selectableLab = JSON.parse(localStorage.getItem('lab'));
    this.selectedLabId = this.selectableLab.lab._id;
    this.resP=new ResP();
    this.enableSubmitButton();
    this.getAllSamples(this.selectedLabId);
    this.getMDMData(this.selectedLabId);
    this.markerNames = ["AHT121", "AHT137", "AHTh130", "AHTh171", "AHTh260", "AHTk211",
      "AHTk253", "AMELOGENIN", "CXX279", "FH2054", "FH2848", "INRA21", "INU005", "INU030", "INU055", "REN105LO3", "REN162C04",
      "REN169D01", "REN169O18", "REN247M23", "REN54P11", "REN64E19"];
  }
  searchForSample() {

    if (this.sampleSearchDisabled) {
      this.sampleSearchDisabled = false;
      return;
    }

    if (this.sampleToSearch == null || this.sampleToSearch == undefined || this.sampleToSearch == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Sample ID Empty', detail: 'Please enter Sample ID to search' });
      return
    }

    if (this.dirty) {
      this.confirmationService.confirm({
        message: this.scanDialogMessage,
        header: 'Discard Changes?',
        accept: () => {
          this.dirty = false;
          this.searchForSampleAction(this.sampleToSearch.trim(), this.selectedLabId);
        },
        reject: () => { }
      });
    } else {
      this.searchForSampleAction(this.sampleToSearch.trim(), this.selectedLabId);
    }
  }
  searchForSampleData(event: any) {
    this.searchForSampleAction(event.data.sampleID, this.selectedLabId)
  }
  searchForSampleAction(barcode: string, labID: string) {
    this.blocked = true;
    this.apgTestingService.getSearchedSample(barcode, labID).subscribe(
      result => {    
        this.searchSample = barcode;
        this.fatherArray = [];
        this.motherArray = [];
        this.childArray = [];
        this.finalData = [];
        if (result && result.data != null && result.data.output) {
          for (let iter of result.data.output) {
            let array = [];  
            array.push(iter);
            array.forEach(element => {
              if (element && element.dna) {
                this.parentsMarkersData(element.dna);
                 this.checkingForSTRPIsPresent(element);
              }
             
              this.allMarkersData();
            });
            break;
          }

        }else{
        this.resP =new ResP();
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'No Data Found',
          detail: 'No data found with the searched sample id '+barcode,
        });
      }
      })
  }

  checkingForSTRPIsPresent(element){
    if(element.order.includes("STR-P") && !element.order.includes("STR")){
      this.childCalculation(element.dna);
      if (element.result && element.result.strP) {
        this.resP =  element.result.strP;
      }else{
        this.resP =new ResP();
      }
      }else{
        if(!element.samplesResult){
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Upload Result',
            detail: 'Please upload result file',
          });
        }else{
          this.childMarkersData(element.samplesResult);
        }    
      }
  }
  childCalculation(dna:any){
    this.childArray=[];
    if (dna.dog != null && dna.dog.isagSTR != null && dna.dog.isagSTR.markers != null && dna.dog != undefined && dna.dog.isagSTR != undefined && dna.dog.isagSTR.markers != undefined) {
      dna.dog.isagSTR.markers.forEach(element => {
        if (element.value != null && element.value != undefined) {
          this.childArray.push(element.value);
        }
      });
    }
  }
  getAllSamples(labId: string) {
    this.blocked = true;
    this.samplesData = [];
    this.finalData=[];
    this.selectedRow=[];
    this.resP=new ResP;
    this.apgTestingService.getSampleSearch(labId).subscribe(
      results => {
        results.output.forEach(element => {
          if (element.result != null) {
              if (element.result && element.result.strP && Object.keys(element.result.strP).length !== 0) {
                this.samplesData.push({ sampleID: element.barcode, misMatchReason: element.result.strP.statusReason ? element.result.strP.statusReason:"Issue with AMELOGENIN" });
              }
          }
         
        });
      }
    )
  }

  getMDMData(labId: string) {
    this._masterDataService.getParentageAnalysis(labId).subscribe(
      results => {
        for (let value of results.data) {
          let arr = [];
          arr.push(value);
          arr.forEach(element => {
            if (element.active) {
              this.subTypeList.push({ label: element.childProfileInExploitable, value: element.childProfileInExploitable });
              element.subType.forEach(ele => {
                this.subTypeList.push({ label: ele.conMisMatch, value: ele.conMisMatch });
                this.subTypeList.push({ label: ele.confMatch, value: ele.confMatch });
                this.subTypeList.push({ label: ele.inExploitableData, value: ele.inExploitableData });
              });
            }
          });
          break;
        }
      })
  }
  updateResultForStrP() {
    this.resP.status="SENT";
    this.apgTestingService.updatingResultInStrP(this.resP,this.selectedLabId, this.searchSample).subscribe(
      results => {
        if(results){
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Succes',
            detail: 'Result of StrP uploaded successfully'
          });
        }    
      })
      
  }
  enableSubmitButton(){
    if(this.resP.result == null || this.resP.result =='' || this.resP.result == undefined){
      return  true;
    }else{
      return false;
    }
  }
  parentsMarkersData(dna:any){
    if (dna.father != null && dna.father.isagSTR != null && dna.father.isagSTR.markers != null && dna.father != undefined && dna.father.isagSTR != undefined && dna.father.isagSTR.markers != undefined) {
     dna.father.isagSTR.markers.forEach(element => {
        if (element.value != null && element.value != undefined) {
          this.fatherArray.push(element.value);
        }
      });
    }
    if (dna.mother != null && dna.mother.isagSTR != null && dna.mother.isagSTR.markers != null && dna.mother != undefined && dna.mother.isagSTR != undefined && dna.mother.isagSTR.markers != undefined) {
      dna.mother.isagSTR.markers.forEach(element => {
        if (element.value != null && element.value != undefined) {
          this.motherArray.push(element.value);
        }
      });
    }
  }
  childMarkersData(sampleResult:any){
    this.childArray=[];
    sampleResult.forEach(element => {
      element.samples.forEach(element => {    
      if ( element.result && element.result.str && element.result.str.markers) {
        let childProfile = element.result.str.markers;
        childProfile.forEach(element => {
          this.childArray.push(element.value);
        });
      }
      if (element.result && element.result.strP) {
        this.resP =  element.result.strP;
      }else{
        this.resP =new ResP();
      }
    });
  });
  }

  removeLeadingZeros(marker:any) : any{
    return marker.replace(/^0+/, '');
  }
  allMarkersData(){
    for (let i = 0; i < this.markerNames.length;i++) {
      let arr = ["markerName", "child", "mother", "father"];
      let obj = {};
      let c= this.childArray[i].split("/");
      obj[arr[0]] = this.markerNames[i];
      let childProfile=[];
      let motherProfile=[];
      let fatherProfile=[];
      let result=[];
      if (this.childArray[i] != null && this.childArray[i] != undefined) {
        childProfile=[{marker:c[0],color:"black"},{marker:c[1],color:"black"}];
      }else{
        childProfile=[{marker:"-",color:"black"},{marker:"-",color:"black"}];
      }
      if (this.motherArray[i] != null && this.motherArray[i] != undefined) {
        let m=this.motherArray[i].split('/');
        motherProfile=[{marker:m[0],color:"black"},{marker:m[1],color:"black"}];
        result = childProfile.filter(c1 => motherProfile.some(m1 => c1.marker === m1.marker));
      } else {
        motherProfile=[{marker:"-",color:"black"},{marker:"-",color:"black"}];
      }
      if (this.fatherArray[i] != null && this.fatherArray[i] != undefined) {
        let f=this.fatherArray[i].split('/');
        
        fatherProfile=[{marker:f[0],color:"black"},{marker:f[1],color:"black"}];
        
      } else {
        fatherProfile=[{marker:"-",color:"black"},{marker:"-",color:"black"}];
      }
      let childMotherMatchIndex = -1;
      let childFatherMatchIndex = -1;
      for(let i in childProfile){
        if(result.length == childProfile.length){
          if(childFatherMatchIndex == -1){
            for(let k in fatherProfile){
              if(childProfile[i].marker != '-' && childProfile[i].marker != '#' && this.removeLeadingZeros(childProfile[i].marker) == this.removeLeadingZeros(fatherProfile[k].marker)){
                  childProfile[i].color = "green";
                  fatherProfile[k].color = "green";
                  childFatherMatchIndex = parseInt(i);
                  break;
              }
            }
          }
          if(childMotherMatchIndex == -1){
            for(let j in motherProfile){
              if(childProfile[i].marker != '-' && childProfile[i].marker != '#' && this.removeLeadingZeros(childProfile[i].marker) == this.removeLeadingZeros(motherProfile[j].marker)){
                if(childProfile[i].color == "black"){
                  childProfile[i].color = "green";
                  motherProfile[j].color = "green";
                  childMotherMatchIndex = parseInt(i);
                break;
                }
              }
            }
          }
        }else{
          if(childMotherMatchIndex == -1){
            for(let j in motherProfile){
              if(childProfile[i].marker != '-' && childProfile[i].marker != '#' && this.removeLeadingZeros(childProfile[i].marker) == this.removeLeadingZeros(motherProfile[j].marker)){
                childProfile[i].color = "green";
                motherProfile[j].color = "green";
                childMotherMatchIndex = parseInt(i);
                break;
              }
            }
          }
          if(childFatherMatchIndex == -1){
          for(let k in fatherProfile){
            if(childProfile[i].marker != '-' && childProfile[i].marker != '#' && this.removeLeadingZeros(childProfile[i].marker) == this.removeLeadingZeros(fatherProfile[k].marker)){
              if(childProfile[i].color == "black"){
                childProfile[i].color = "green";
                fatherProfile[k].color = "green";
                childFatherMatchIndex = parseInt(i);
                break;
              }
            }
          }
        }
        }
        
     

      }

      if(childMotherMatchIndex == -1 && childFatherMatchIndex == -1){
        childProfile[0].color = "black";
        childProfile[1].color = "black";
        fatherProfile[0].color = "black";
        fatherProfile[1].color = "black";
        motherProfile[0].color = "black";
        motherProfile[1].color = "black";
        if(childProfile[0].marker !='-' && childProfile[1].marker !='-' && childProfile[0].marker !='#' && childProfile[1].marker !='#' ){
          childProfile[0].color = "red";
        childProfile[1].color = "red";
        fatherProfile[0].color = "red";
        fatherProfile[1].color = "red";
        motherProfile[0].color = "red";
        motherProfile[1].color = "red";
          obj["rowColor"] = "yellow";
        } 
      }else if(childMotherMatchIndex == -1 && motherProfile[0].marker !='-' && motherProfile[1].marker !='-' && motherProfile[0].marker !='#' && motherProfile[1].marker !='#' ){
        let i = childFatherMatchIndex == 1 ? 0:1;
        childProfile[i].color = "red";
        motherProfile[0].color = "red";
        motherProfile[1].color = "red";
        obj["rowColor"] = "yellow";
      }else if(childFatherMatchIndex == -1 && fatherProfile[0].marker !='-' && fatherProfile[1].marker !='-' && fatherProfile[0].marker !='#' && fatherProfile[1].marker !='#' ){
        let i = childMotherMatchIndex == 1 ? 0:1;
        childProfile[i].color = "red";
        fatherProfile[0].color = "red";
        fatherProfile[1].color = "red";
        obj["rowColor"] = "yellow";
      }
      obj[arr[1]] = childProfile;
      obj[arr[2]] = motherProfile;
      obj[arr[3]] = fatherProfile;
      this.finalData.push(obj);
   
    }
  }
}